import styled from 'styled-components';

import LoadingAnimation from 'components/loading-animation';

import { getWidgetSpacing } from '../utils';

export const Container = styled.section`
  padding: ${getWidgetSpacing.vertical()} ${getWidgetSpacing.horizontal()};
  ${Styles.desktop`
      padding: ${getWidgetSpacing.vertical('desktop')} 0;
  `}
`;

export const HeadingText = styled.h5`
  color: ${Styles.color.teal};
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.375rem;
  text-align: left;
  margin: 0;
  ${Styles.desktop`
    font-size: 1.625rem;
  `}
`;

export const StyledLoadingAnimation = styled(LoadingAnimation)`
  height: 12rem;
  ${Styles.desktop`
    height: 14rem;
  `}
`;
